import { render, staticRenderFns } from "./podProviders.vue?vue&type=template&id=0b3e5214"
import script from "./podProviders.vue?vue&type=script&lang=js"
export * from "./podProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports